import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter4 from "../components/Transmitter4";
import Transmitter from "../components/Transmitter";
import "./TestSeparator.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import TestSeparatorAnalysis from "../components/TestSeparatorAnalysis";

import { trackPageVisit } from "../competency/PageTracker";





 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


              

function TestSeparator() {

        useEffect(() => {
  
    trackPageVisit("TestSeparator");
  
  }, []);

  const {  valves, toggleValve, transmitters} = useContext(WellContext);
  const [openAnalysis, setOpenAnalysis] = useState(false);

  const DEFAULT_VALVES = {
  FCV_13001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_13003: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_13005: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_13006: { mode: "Manual", opening: 0, sp: "", pv: "" },
};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("GasLiftManifold_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_13001: { ...DEFAULT_VALVES.FCV_13001, ...parsed.FCV_13001 },
      FCV_13003: { ...DEFAULT_VALVES.FCV_13003, ...parsed.FCV_13003 },
      FCV_13005: { ...DEFAULT_VALVES.FCV_13005, ...parsed.FCV_13005 },
      FCV_13006: { ...DEFAULT_VALVES.FCV_13006, ...parsed.FCV_13006 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});


/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("TestSeparator_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= INFLOW LOGIC from TEST HEADER to TEST SEPARATOR CRUDE LEVEL TRANSMITTER =================
     

      const isValveOpen = valves?.XV_13001 === false;

      const crudeFlow = transmitters?.MPFT_10601 || 0;

      const inflows = (isValveOpen && crudeFlow > 0)
        ? [crudeFlow / 60 * 159]
        : [];


        const waterFlow = transmitters?.MPFT_10603 || 0;

        const inflows2 = (isValveOpen && waterFlow > 0)
          ? [waterFlow / 60]
          : [];


       const gasFlow = transmitters?.MPFT_10602 || 0;

        const FIC_13002 = isValveOpen ? gasFlow : 0;





        

        const isXV_13004Open = valves?.XV_13004 === false;
        const isXV_13005Open = valves?.XV_13005 === false;
        const isXV_13006Open = valves?.XV_13006 === false;

        // First flow (direct from FCV)
        const targetFIC_13007 = isXV_13004Open
        ? gasFlow * ((valveData?.FCV_13001?.opening || 0) / 100)
        : 0;

         const [FIC_13007, setFIC_13007] = useState(() => {
        return Number(localStorage.getItem("FIC_13007")) || 0;
      }); 

    useEffect(() => {
        const interval = setInterval(() => {
          setFIC_13007(prev => {
            const diff = targetFIC_13007 - prev;

            // smoothing factor (tune this)
            const step = diff * 0.1;

            // snap when very close
            if (Math.abs(diff) < 0.001) return targetFIC_13007;

            return prev + step;
          });
        }, 200); // speed of update

        return () => clearInterval(interval);
      }, [targetFIC_13007]);

      useEffect(() => {
            localStorage.setItem("FIC_13007", FIC_13007);
          }, [FIC_13007]);


        

        // Remaining gas after first split
        let FIC_13003 = isXV_13004Open  ?  gasFlow - FIC_13007 : 0;


      const { setTransmitters } = useContext(WellContext);
          useEffect(() => {
              setTransmitters(prev => ({
                ...prev,
                FIC_13003: FIC_13003
              }));
            }, [FIC_13003, setTransmitters]);




   
        const remaining = Math.max(FIC_13002 - FIC_13003, 0);

        let FIC_13004 = 0; // XV_13006
        let FIC_13009 = 0; // XV_13005

        if (isXV_13006Open && isXV_13005Open) {
          // both open → split
          FIC_13004 = remaining * 0.5;
          FIC_13009 = remaining * 0.5;

        } else if (isXV_13006Open) {
          // only 13006 open
          FIC_13004 = remaining;

        } else if (isXV_13005Open) {
          // only 13005 open
          FIC_13009 = remaining;

        }
        // if both closed → both remain 0

// ================= TOTAL FLUID FLOW from TEST HEADER to TEST SEPARATOR CRUDE LEVEL TRANSMITTER =================
      const [FIC_13001, setFIC_13001] = useState(() => {
        return Number(localStorage.getItem("FIC_13001")) || 0;
      });        
      const targetFIC_13001 = useMemo(() => {
          const fic = Number(transmitters?.FIC_10601 ?? 0);
          return valves?.XV_13001 === false ? fic : 0.03;
        }, [transmitters?.FIC_10601, valves?.XV_13001]);

        useEffect(() => {
          const interval = setInterval(() => {
            setFIC_13001(prev => {
              const diff = targetFIC_13001 - prev;

              // FLOW responds fastest in real systems
              const step = diff * 0.12;

              // snap when very close
              if (Math.abs(diff) < 0.001) return targetFIC_13001;

              return prev + step;
            });
          }, 200);

          return () => clearInterval(interval);
        }, [targetFIC_13001]);

      useEffect(() => {
            localStorage.setItem("FIC_13001", FIC_13001);
          }, [FIC_13001]);

    

  // ================= PRESSURE from TEST HEADER to TEST SEPARATOR CRUDE LEVEL TRANSMITTER =================
      const [PT_13001, setPT_13001] = useState(() => {
        return Number(localStorage.getItem("PT_13001")) || 0;
      });   
      const targetPT_13001 = useMemo(() => {
        const pt = Number(transmitters?.PT_10601 ?? 0);
        return valves?.XV_13001 === false ? pt : 0.03;
      }, [transmitters?.PT_10601, valves?.XV_13001]);

      useEffect(() => {
        const interval = setInterval(() => {
          setPT_13001(prev => {
            const diff = targetPT_13001 - prev;

            // smoothing factor (tune this)
            const step = diff * 0.08;

            // snap when very small difference
            if (Math.abs(diff) < 0.001) return targetPT_13001;

            return prev + step;
          });
        }, 200); // update speed

        return () => clearInterval(interval);
      }, [targetPT_13001]);

      useEffect(() => {
            localStorage.setItem("PT_13001", PT_13001);
          }, [PT_13001]);

        
       const PT_13002 = isValveOpen ? PT_13001 - (PT_13001 * 0.0989) : 0.03;
       const PT_13003 = isXV_13004Open ? PT_13002 - (PT_13002 * 0.0989) : 0.03;
       const PT_13009 = isXV_13005Open ? PT_13002 - (PT_13002 * 0.0993) : 0.03;
       const PT_13004 = isXV_13006Open ? PT_13002 - (PT_13002 * 0.0993) : 0.03;

       useEffect(() => {
            localStorage.setItem("PT_13004", PT_13004);
          }, [PT_13004]);

          useEffect(() => {
            localStorage.setItem("PT_13004", PT_13004);
          }, [PT_13004]);








      useEffect(() => {
              setTransmitters(prev => ({
                ...prev,
                PT_13003: PT_13003
              }));
            }, [PT_13003, setTransmitters]);

  // ================= TEMPERATURE from TEST HEADER to TEST SEPARATOR CRUDE LEVEL TRANSMITTER =================

         const [TT_13001, setTT_13001] = useState(() => {
        return Number(localStorage.getItem("TT_13001")) || 0;
      });   

        const targetTT_13001 = useMemo(() => {
          const tt = Number(transmitters?.TT_10601 ?? 0);
          return valves?.XV_13001 === false ? tt : 22;
        }, [transmitters?.TT_10601, valves?.XV_13001]);

        useEffect(() => {
          const interval = setInterval(() => {
            setTT_13001(prev => {
              const diff = targetTT_13001 - prev;

              // slower response than pressure (thermal inertia)
              const step = diff * 0.05;

              // snap when very close
              if (Math.abs(diff) < 0.001) return targetTT_13001;

              return prev + step;
            });
          }, 200);

          return () => clearInterval(interval);
        }, [targetTT_13001]);

         useEffect(() => {
            localStorage.setItem("TT_13001", TT_13001);
          }, [TT_13001]);


       const TT_13002 = isValveOpen ? TT_13001 - (TT_13001 * 0.0989) : 22;
       const TT_13004 = isXV_13006Open ? TT_13002 - (TT_13002 * 0.0989) : 22;
       const TT_13009 = isXV_13005Open ? TT_13002 - (TT_13002 * 0.0989) : 22;




// =================  DECREMENTING CRUDE LEVEL OF TEST SEPARATOR CHAMBER =================

      const isXV_13002Open = valves?.XV_13002 === false;

      const crudeFlowRateTestSeparator = 50.576
       const FIC_13008 = isXV_13002Open ? crudeFlowRateTestSeparator * ((valveData?.FCV_13006?.opening || 0) / 100) : 0;

      const FIC_13008a = isXV_13002Open ? FIC_13008 * 24 : 0;
       const crudeDensity = 855.565;
      const FIC_13008b = isXV_13002Open ? (FIC_13008 / 1000 / 60) * crudeDensity : 0;

      const TT_13008a = isXV_13002Open ? TT_13002 -(TT_13002 * 0.098) :22;


// ================= DECREMENTING WATER LEVEL OF TEST SEPARATOR CHAMBER =================

      const isXV_13003Open = valves?.XV_13003 === false;

      const waterFlowRateTestSeparator = 100.942;
       const FIC_13006 = isXV_13003Open ? waterFlowRateTestSeparator * ((valveData?.FCV_13005?.opening || 0) / 100) : 0;
       const FIC_13006a = isXV_13003Open ? FIC_13006 * 24 : 0;

       const waterDensity = 993.565;
      const FIC_13006b = isXV_13003Open ? (FIC_13006 / 1000 / 60) * waterDensity : 0;
       
      const TT_13006a = isXV_13003Open ? TT_13002 -(TT_13002 * 0.198) :22;


          useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              FIC_13006: FIC_13006
            }));
          }, [FIC_13006]);


          useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              FIC_13008: FIC_13008
            }));
          }, [FIC_13008]);


           useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              TT_13006a: TT_13006a
            }));
          }, [TT_13006a]);





  // ================= DECREMENTING IMPURITY LEVEL OF TEST SEPARATOR CHAMBER =================
        const impurityFlowRateTestSeparator = 100.675;
       const FIC_13005 = impurityFlowRateTestSeparator * ((valveData?.FCV_13003?.opening || 0) / 100);
      
 

          useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              FIC_13009: FIC_13009
            }));
          }, [FIC_13009]);

          useEffect(() => {
            setTransmitters(prev => ({
              ...prev,
              PT_13009: PT_13009
            }));
          }, [PT_13009]);

           useEffect(() => {
                    localStorage.setItem("FIC_13007", FIC_13007);
                  }, [FIC_13007]);


  return (

        <div className="TestSeparator-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "322px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "2.2px 263px"
      }}>
        TEST SEPARATOR
      </h2>


    {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-10905 */}
      <Valve
        className="XV-13001"
        tag="XV_13001"
        x={200}
        y={128}
        isClosed={valves.XV_13001}
        toggle={toggleValve}
      />

            {/* XV-11002 */}
      <Valve
        className="XV-13002"
        tag="XV_13002"
        x={555}
        y={400}
        isClosed={valves.XV_13002}
        toggle={toggleValve}
        r={90}
      />



      
      {/* XV-11003 */}
      <Valve
        className="XV-13003"
        tag="XV_13003"
        x={428}
        y={445}
        isClosed={valves.XV_13003}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-13004 */}
      <Valve
        className="XV-13004"
        tag="XV_13004"
        x={850}
        y={148}
        isClosed={valves.XV_13004}
        toggle={toggleValve}
      />

      
      {/* XV-13005 */}
      <Valve
        className="XV-13005"
        tag="XV_13005"
        x={1140}
        y={398}
        isClosed={valves.XV_13005}
        toggle={toggleValve}
      />

         
      {/* XV-13006 */}
      <Valve
        className="XV-13006"
        tag="XV_13006"
        x={1180}
        y={488}
        isClosed={valves.XV_13006}
        toggle={toggleValve}
      />


      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-13001 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-13001"
          style={{ position: "absolute", left: 733, top: 94, transform: "rotate(270deg)", transformOrigin: "center" }}  onClick={() => openPanel("FCV_13001")}>
          
          <defs>
            <linearGradient id="metal_13001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_13001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_13001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        {/* FCV-13003 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-13003"
          style={{ position: "absolute", left: 229, top: 483 }}  onClick={() => openPanel("FCV_13003")}>
          
          <defs>
            <linearGradient id="metal_13003">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_13003)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_13003)" stroke="#7f8c8d" strokeWidth="2" />

          


        </svg>
        {/* FCV-13005 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-13005"
          style={{ position: "absolute", left: 580, top: 660 }}  onClick={() => openPanel("FCV_13005")}>
          
          <defs>
            <linearGradient id="metal_13005">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_13005)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_13005)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        {/* FCV-13006 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-13006"
          style={{ position: "absolute", left: 933, top: 586}}  onClick={() => openPanel("FCV_13006")}>
          
          <defs>
            <linearGradient id="metal_13006">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_13006)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_13006)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        
     
      {/* ================= FACEPLATES ================= */}
      {openPanels.map((tag, index) => (
        <ControlValveControlPanel
          key={tag}
          tag={tag}
          data={valveData[tag]}
          update={updateValveData}   // ✅ FIXED
          close={() => closePanel(tag)}
          defaultPosition={{
            x: 300 + index * 40,
            y: 150 + index * 40
          }}
        />
      ))}


      <div
          style={{
            position: "absolute", left: 100, top: 160,
            background: "#0ea5e9",
            color: "white",
            padding: "2px 2px",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "600",
            boxShadow: "0 0 10px rgba(0,0,0,0.4)"
          }}
          onClick={() => setOpenAnalysis(true)}
        >
          Sample
        </div>




      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_13001?.opening || 0)}
        x={790}
        y={109}
      />

      <ValveOutput
        value={Number(valveData?.FCV_13003?.opening || 0)}
        x={250}
        y={523}
      />

      <ValveOutput
        value={Number(valveData?.FCV_13005?.opening || 0)}
        x={600}
        y={704}
      />
      <ValveOutput
        value={Number(valveData?.FCV_13006?.opening || 0)}
        x={957}
        y={628}
      />

      /* LEVEL GUAGE/INDICATOR  */

      <LevelTransmitterIndicator
      tag="LT_13001"
      totalLevel={10000}
      inflows={inflows}
      outflows={[FIC_13008]}
      responseFactor={0.05}
      columnX={548}
      columnY={220}
      columnWidth={30}
      columnHeight={120}
      textX={635}
      textY={230}
      showFlow={true}
    />

    <LevelTransmitterIndicator
      tag="LT_13002"
      totalLevel={10000}
      inflows={[inflows2]}
      outflows={[FIC_13006]}
      responseFactor={0.05}
      columnX={420}
      columnY={285}
      columnWidth={30}
      columnHeight={120}
      textX={341}
      textY={360}
      showFlow={true}
    />

    <Transmitter
    tag= "FIC-13001"
      value={FIC_13001}
      x={257}
      y={118}
      c="lime"
      unit="BOE/M"
      max={200}
      HH={180}
      H={170}
      L={5}
      LL={1}
      description="FLOWRATE OF FLUID FROM NK-1, NK-2 & NK-3 WELLHEADS THROUGH TEST HEADER MANIFOLD TO TEST SEPARATOR."
    />
   
    <Transmitter
      value={FIC_13002}
      x={607}
      y={118}
      unit="SCF/S"
      max={100}
      HH={95}
      H={90}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS AT GAS OUTLET OF TEST SEPARATOR TO STAGE SEPARATIONS"
      tag="FIC-13002"
    />

    <Transmitter
      value={FIC_13007}
      x={1139}
      y={81}
      unit="SCF/S"
      max={50}
      HH={45}
      H={40}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS AT TEST SEPARATOR PSV OUTLET LINE TO FLARE HEADER"
      tag="FIC-13007"
    />

    <Transmitter
      value={FIC_13005}
      x={150}
      y={469}
      unit="LPM"
      max={20}
      HH={15}
      H={10}
      L={1}
      LL={0.1}
      c="lime"
      description="FLOWRATE OF WATER AND SEDIMENT TO CLOSE DRAIN FROM TEST SEPARATOR"
      tag="FIC-13005"
     />

    <Transmitter
      value={FIC_13006}
      x={460}
      y={536}
      unit="LPM"
      max={20}
      HH={18}
      H={16}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF TEST SEPARATOR TO DE-OILER VESSEL"
      tag="FIC-13006"
    />

    <Transmitter
      value={FIC_13006a}
      x={459}
      y={545}
      unit="LPD"
      max={400}
      HH={385}
      H={350}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF TEST SEPARATOR TO DE-OILER VESSEL"
      tag="FIC-13006A"
    />

    <Transmitter
      value={FIC_13006b}
      x={460}
      y={554}
      unit="kg/m3"
      max={2}
      HH={1.5}
      H={1.8}
      L={0.08}
      LL={0.03}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF TEST SEPARATOR TO DE-OILER VESSEL"
      tag="FIC-13006B"
    />

    <Transmitter
      value={TT_13006a}
      x={460}
      y={564}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="FLOWRATE OF WATER FROM OUTLET OF TEST SEPARATOR TO DE-OILER VESSEL"
      tag="TT-13006A"
    />

    <Transmitter
      value={FIC_13008}
      x={610}
      y={536}
      unit="BPM"
      max={300}
      HH={285}
      H={270}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF TEST SEPARATOR TO 3RD STATE SEPARATOR"
      tag="FIC-13008"
    />

    <Transmitter4
      value={FIC_13008a}
      x={610}
      y={544}
      c="lime"
    />
    <Transmitter
      value={FIC_13008a}
      x={610}
      y={544}
      unit="BPD"
      max={7750}
      HH={7745}
      H={7240}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF TEST SEPARATOR TO 3RD STATE SEPARATOR"
      tag="FIC-13008A"
    />

    <Transmitter
      value={FIC_13008b}
      x={610}
      y={553}
      unit="kg/m3"
      max={5}
      HH={4.23}
      H={3.8}
      L={0.05}
      LL={0.003}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF TEST SEPARATOR TO 3RD STATE SEPARATOR"
      tag="FIC-13008B"
    />
   
    <Transmitter
      value={TT_13008a}
      x={610}
      y={563}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="FLOWRATE OF CRUDE FROM OUTLET OF TEST SEPARATOR TO 3RD STATE SEPARATOR"
      tag="TT-13008A"
    />

    <Transmitter
      value={FIC_13003}
      x={1025}
      y={118}
      unit="SCF/S"
      max={100}
      HH={95}
      H={90}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS TO 1ST STAGE SEPARATOR"
      tag="FIC-13003"
    />

    <Transmitter
      value={FIC_13004}
      x={934}
      y={470}
      unit="SCF/S"
      max={100}
      HH={95}
      H={90}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS 3RD STAGE SEPARATOR"
      tag="FIC-13004"
    />

    <Transmitter
      value={FIC_13009}
      x={949}
      y={371}
      unit="SCF/S"
      max={100}
      HH={95}
      H={90}
      L={5}
      LL={3}
      c="lime"
      description="FLOWRATE OF GAS 2nd STAGE SEPARATOR"
      tag="FIC-13009"
    />

    <Transmitter
      value={PT_13001}
      x={355}
      y={147}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF TEST SEPARATOR VESSEL"
      tag="PT-13001"
     />

    <Transmitter
      value={PT_13002}
      x={532}
      y={118}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS AT GAS OUTLET OF TEST SEPARATOR TO STAGE SEPARATION LINES"
      tag="PT-13002"
     />

    <Transmitter
      value={PT_13003}
      x={934}
      y={118}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS TO 1ST STAGE SEPARATOR"
      tag="PT-13003"
     />

    <Transmitter
      value={PT_13004}
      x={860}
      y={470}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS TO 3RD STAGE SEPARATOR"
      tag="PT-13004"
     />
    <Transmitter
      value={PT_13009}
      x={873}
      y={372}
      unit="MPa"
      max={15}
      HH={14}
      H={10}
      L={0.3}
      LL={0.033}
      c="lime"
      description="PRESSURE OF GAS TO 3RD STAGE SEPARATOR"
      tag="PT-13009"
     />
    
    <Transmitter
      value={TT_13001}
      x={100}
      y={117}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF CRUDE FROM TEST HEADER"
      tag="TT-13001"
     />

    <Transmitter
      value={TT_13002}
      x={442}
      y={146}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF TEST SEPARATOR VESSEL"
      tag="TT-13002"
     />

    <Transmitter
      value={TT_13004}
      x={1085}
      y={470}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF GAS TO 3RD STAGE SEPARATOR"
      tag="TT-13004"
     />

    <Transmitter
      value={TT_13009}
      x={1040}
      y={372}
      unit="°C"
      max={150}
      HH={145}
      H={140}
      L={25}
      LL={23}
      c="lime"
      description="TEMPERATURE OF GAS TO 2ND STAGE SEPARATOR"
      tag="TT-13009"
     />




    <TestSeparatorAnalysis
      open={openAnalysis}
      onClose={() => setOpenAnalysis(false)}
    />

    

      

    </div>
  );
}

export default TestSeparator;
